import { useState, useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import PauseCircleOutlineIcon from "@material-ui/icons/PauseCircleOutline";
import PlayCircleFilledOutlined from "@material-ui/icons/PlayCircleFilledOutlined";
import { AudioUploadService } from "../../../service/transcribe/AudioUploadService";
import AWS from "aws-sdk";
import ApiService from "../../../ApiService";

const mimeType = "audio/webm";
const S3_BUCKET = "tbd-transcribe-generic";
const REGION = "us-east-1";
const ACCESS_KEY = "AKIAUSX6JVFKLD4EASV4";
const SECRET_ACCESS_KEY = "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";

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});
const s3 = new AWS.S3({
  region: REGION,
  params: { Bucket: S3_BUCKET },
});

const AudioRecorder = ({ handlePause, handleResume, handleStart, handleReset, setAudio, fileId }) => {
  const mediaRecorder = useRef(null);
  const uploader = useRef(null);
  const intervalId = useRef(null);
  const localAudioChunksRef = useRef([]);

  const [partNumber, setPartNumber] = useState(1);
  const [permission, setPermission] = useState(false);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [stream, setStream] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);

  const [isPause, setPause] = useState(false);
  useEffect(() => {
    if (fileId) {
      uploader.current = new AudioUploadService(s3, S3_BUCKET, `${fileId}/audio.webm`);
    }
  }, [fileId]);

  useEffect(() => {
    if (mediaRecorder.current) {
      mediaRecorder.current.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: mimeType });
        const audioUrl = URL.createObjectURL(audioBlob);
        uploader.current.completeMultipartUpload(audioBlob, onUploadComplete);
        setAudio(audioUrl);
        setAudioChunks([]);
        handleReset();
      };

      mediaRecorder.current.ondataavailable = async (event) => {
        if (typeof event.data === "undefined") return;
        if (event.data.size === 0) return;

        localAudioChunksRef.current.push(event.data);
        setAudioChunks((prev) => [...prev, event.data]);
        const audioBlob = new Blob(localAudioChunksRef.current, { type: "audio/webm" });

        if (!uploader.current.uploadId) return console.log("Upload ID not set yet, skipping upload for this chunk.");

        if (audioBlob.size >= 5 * 1024 * 1024) {
          await uploader.current.uploadPart(audioBlob, partNumber, (err, data) => {
            if (err) {
              console.log(err);
              return;
            }
            console.log(`Successfully uploaded chunk #${partNumber}.`, data);
            setPartNumber(partNumber + 1);
            localAudioChunksRef.current = [];
          });
        } else {
          console.log(`Current blob size: ${(audioBlob.size / (1024 * 1024)).toFixed(2)} MB. Accumulating more data.`);
        }
      };
    }
  }, [audioChunks, handleReset, setAudio, mediaRecorder]);

  useEffect(() => {
    intervalId.current = setInterval(() => {
      if (mediaRecorder.current && mediaRecorder.current.state === "recording") {
        mediaRecorder.current.requestData();
      }
    }, 30_000);
    return () => {
      clearInterval(intervalId.current);
    };
  }, [mediaRecorder]);

  const getMicrophonePermission = async () => {
    if ("MediaRecorder" in window) {
      try {
        const streamData = await navigator.mediaDevices
          .getUserMedia({
            audio: true,
            video: false,
          })
          .then();
        setPermission(true);
        setStream(streamData);
      } catch (err) {
        alert(err.message);
      }
    } else {
      alert("The MediaRecorder API is not supported in your browser.");
    }
  };

  const startRecording = async () => {
    try {
      setRecordingStatus("recording");
      handleStart();
      //create new Media recorder instance using the stream
      const media = new MediaRecorder(stream, { type: mimeType });
      //set the MediaRecorder instance to the mediaRecorder ref
      mediaRecorder.current = media;

      // Start the multipart upload process
      await uploader.current.startMultipartUpload();
      //invokes the start method to start the recording process
      mediaRecorder.current.start();
    } catch (error) {
      console.log(error);
      console.log(error.message);
    }
  };

  const stopRecording = async () => {
    setRecordingStatus("inactive");
    mediaRecorder.current.stop();
  };

  const pause = () => {
    mediaRecorder.current.pause();
    setPause(true);
    handlePause();
  };
  const resume = () => {
    mediaRecorder.current.resume();
    setPause(false);
    handleResume();
  };
  const onUploadComplete = (err, data) => {
    if (err) {
      console.log(err);
      return;
    }
    ApiService.updateTranscribeStatus(fileId, {
      status: "AUDIO_UPLOADED",
    });
  };
  return (
    <div className="audio-controls">
      <div className="mt-3" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        {!permission ? (
          <Button onClick={getMicrophonePermission} className="record-btn">
            Get Microphone
          </Button>
        ) : null}

        {permission && recordingStatus === "inactive" ? (
          <Button onClick={startRecording} className="record-btn">
            Start Recording
          </Button>
        ) : null}
      </div>

      {recordingStatus === "recording" ? (
        <div className="mt-3" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          {isPause ? (
            <Button onClick={resume} style={{ borderRadius: "16px" }} className="btn-light">
              <PlayCircleFilledOutlined style={{ fill: "#000" }} />
            </Button>
          ) : (
            <Button onClick={pause} style={{ borderRadius: "16px" }} className="btn-light">
              <PauseCircleOutlineIcon style={{ fill: "#000" }} />
            </Button>
          )}
          <Button onClick={stopRecording} className="record-btn">
            Stop Recording
          </Button>
        </div>
      ) : null}
    </div>
  );
};
export default AudioRecorder;
